import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { slugify, getDataAttributes } from '@nicollet/common';
import { ErrorMessage } from '../ErrorMessage/index.js';
import { CheckboxOuterWrap, CheckboxInput, CheckboxWrap, CheckboxVisual, CheckboxLabel, CheckboxMicrocopy } from './styles.js';

const Checkbox = forwardRef((props, ref) => {
  const {
    ariaLabel,
    autoComplete,
    autoFocus = false,
    checked = false,
    children,
    className,
    disabled = false,
    disableLiveRegion,
    errorText,
    hasActive,
    hasFocus,
    hasHover,
    hideLabel = false,
    id,
    isValid,
    label,
    microcopy,
    name,
    onBlur,
    onChange,
    onFocus,
    readOnly,
    required = false,
    screenReader,
    value
  } = props; // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing

  const labelContent = label || children;
  const transformedLabelContent = typeof labelContent === 'string' ? slugify(labelContent) : 'Check me!'; // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing

  const idContent = id || transformedLabelContent || 'default-id-change-me';

  if (process.env.NODE_ENV === 'development' && (!id || id === '')) {
    // eslint-disable-next-line no-console
    console.warn("Warning: No 'id' prop provided for Checkbox. This will become a required prop for Checkbox in the upcoming Nicollet v8 release.");
  } // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing


  const nameContent = name || idContent;
  const classNameContent = className ? `${className} nds-checkbox` : 'nds-checkbox';
  const dataAttributes = getDataAttributes(props);
  const inputElementAttributes = {
    autoComplete,
    autoFocus,
    disabled,
    onBlur,
    onChange,
    onFocus,
    required,
    value
  };
  return jsxs(CheckboxOuterWrap, Object.assign({
    className: classNameContent
  }, dataAttributes, {
    children: [jsx(CheckboxInput, Object.assign({}, inputElementAttributes, {
      "aria-label": ariaLabel,
      checked: checked,
      id: idContent,
      name: nameContent,
      readOnly: readOnly,
      ref: ref,
      type: "checkbox"
    }), void 0), jsxs(CheckboxWrap, Object.assign({
      hasFocus: hasFocus,
      htmlFor: idContent
    }, {
      children: [jsx(CheckboxVisual, {
        hasActive: hasActive,
        hasHover: hasHover,
        hiddenLabel: hideLabel,
        valid: isValid
      }, void 0), jsx(CheckboxLabel, {
        disabled: disabled,
        disableLiveRegion: disableLiveRegion,
        errorText: errorText,
        hasActive: hasActive,
        hasHover: hasHover,
        hidden: hideLabel,
        label: labelContent,
        microcopy: microcopy,
        screenReader: screenReader,
        tag: "span",
        valid: isValid
      }, void 0), microcopy && jsx(CheckboxMicrocopy, Object.assign({
        "aria-hidden": "true"
      }, {
        children: microcopy
      }), void 0)]
    }), void 0), isValid === false && errorText && jsx(ErrorMessage, Object.assign({
      "aria-hidden": "true"
    }, {
      children: errorText
    }), void 0)]
  }), void 0);
}); // @ts-ignore

Checkbox.displayName = 'Checkbox';

export { Checkbox };
